import React, { useEffect, useState } from "react";
import api from "../../api/api";
import toast from "react-hot-toast";
import {
  Newspaper,
  MessageSquare,
  Mail,
  FileText,
  Home,
  ExternalLink,
} from "lucide-react";

const Stat = ({ icon: Icon, label, value }) => (
  <div className="bg-white rounded-3xl p-6 shadow-sm border">
    <div className="w-12 h-12 rounded-2xl bg-[#0b6b1d]/10 text-[#0b6b1d] flex items-center justify-center mb-4">
      <Icon size={22} />
    </div>

    <p className="text-slate-500 text-sm">{label}</p>
    <h3 className="text-3xl font-black text-slate-900 mt-1">{value}</h3>
  </div>
);

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);

  const loadStats = async () => {
    try {
      const res = await api.get("/admin/dashboard");
      setStats(res.data);
    } catch (err) {
      toast.error(err.cleanMessage || "Failed to load dashboard.");
    }
  };

  useEffect(() => {
    loadStats();
  }, []);

  if (!stats) return <p>Loading dashboard...</p>;

  return (
    <div>
      <div className="bg-white rounded-3xl p-6 shadow-sm border mb-8 flex flex-col md:flex-row md:items-center md:justify-between gap-5">
        <div>
          <h1 className="text-2xl md:text-3xl font-black text-[#0b6b1d]">
            Welcome to OGFZA CMS Dashboard
          </h1>

          <p className="text-slate-600 mt-2 leading-7">
            You are logged into the OGFZA administration area. Manage website
            content, posts, announcements, media, contacts and other CMS
            sections from here.
          </p>
        </div>

        <a
          href="/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-2xl bg-[#0b6b1d] text-white font-bold hover:bg-[#201182] transition-all duration-300"
        >
          <Home size={18} />
          Open Homepage
          <ExternalLink size={16} />
        </a>
      </div>

      <div className="grid sm:grid-cols-2 xl:grid-cols-5 gap-5 mb-8">
        <Stat icon={Newspaper} label="Total Posts" value={stats.posts} />
        <Stat icon={FileText} label="Published" value={stats.published_posts} />
        <Stat icon={FileText} label="Drafts" value={stats.draft_posts} />
        <Stat
          icon={MessageSquare}
          label="Pending Comments"
          value={stats.pending_comments}
        />
        <Stat
          icon={Mail}
          label="Subscribers"
          value={stats.newsletter_subscribers}
        />
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <section className="bg-white rounded-3xl p-6 shadow-sm border">
          <h2 className="font-black text-xl text-[#0b6b1d] mb-4">
            Recent Posts
          </h2>

          <div className="space-y-3">
            {stats.recent_posts?.length > 0 ? (
              stats.recent_posts.map((post) => (
                <div key={post.id} className="border rounded-2xl p-4">
                  <p className="font-bold">{post.title}</p>
                  <span className="text-xs text-slate-500">{post.status}</span>
                </div>
              ))
            ) : (
              <p className="text-sm text-slate-500">No recent posts found.</p>
            )}
          </div>
        </section>

        <section className="bg-white rounded-3xl p-6 shadow-sm border">
          <h2 className="font-black text-xl text-[#0b6b1d] mb-4">
            Recent Contacts
          </h2>

          <div className="space-y-3">
            {stats.recent_contacts?.length > 0 ? (
              stats.recent_contacts.map((item) => (
                <div key={item.id} className="border rounded-2xl p-4">
                  <p className="font-bold">{item.subject}</p>
                  <span className="text-xs text-slate-500">{item.email}</span>
                </div>
              ))
            ) : (
              <p className="text-sm text-slate-500">
                No recent contact messages found.
              </p>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default AdminDashboard;